import React, { ReactElement } from 'react';

import Icon from 'atomic/icon/icon';
import type { ReviewListObjectType } from 'modules/review/review.interface';
import Link from 'atomic/link/link';

const reviewTypeLabels = {
    shop: 'Sklep',
    firm: 'Firma',
    exchange: 'Firma',
    courier: 'Firma',
    product: 'Produkt'
};

const ReviewListBlank: React.FC<{ objectType: ReviewListObjectType; isReviewable?: boolean; }> = ({ objectType, isReviewable }): ReactElement => (
    <div className="review-list__blank">
        <Icon icon="no-comment" className="review-list__blank-icon" />
        <div className="review-list__blank-header">
            brak opinii
        </div>
        <p className="review-list__blank-text">
            {`${reviewTypeLabels[objectType]} `}
            nie posiada jeszcze opinii. Bądź pierwszy i wystaw opinię.
        </p>
        {isReviewable && <Link uppercase={true} type="button" href="#zawartosc">
            dodaj opinię
        </Link>}
    </div>
);

export default ReviewListBlank;
